// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BLOGS_ADD_NEW_COMMENT_PLACEHOLDER = "Za\u010dni ps\u00e1t koment\u00e1\u0159...";
export const FORUM_COMMENT_FORM_EMPTY_MESSAGE_CANNOT_BE_SENT = "Pr\u00e1zdnou zpr\u00e1vu nem\u016f\u017ee\u0161 odeslat";
export const SEND_AS_ADMIN = "oznam MK";
export const SEND_COMMENT_FORUM = "Ode\u0161li";
